import { Experiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'
import { resolveRebrandVersion, type RebrandVersion } from 'lib/theme/paletteVersion'

/** Resolves the active rebrand palette version from the canonical experiment hook. */
function useRebrandVersion(): RebrandVersion {
  const { variation } = useExperiment(Experiments.croRebrand, {
    canActivate: false,
    overrideTrigger: true,
  })

  return resolveRebrandVersion(variation)
}

export default useRebrandVersion
